<div class="item-loading">
  <span class="pulse"></span>
</div>
